// styling
import styles from "./style.module.scss";
// components
import Ticker from "@components/Ticker";
import LazyImage from "@components/LazyImage";
import Spring from "@components/Spring";
// assets
import wallet from "@assets/icons/wallet.svg";
import folder from "@assets/icons/folder.svg";
import cloud from "@assets/icons/cloud.svg";
import tags from "@assets/icons/tags.svg";
import HowToVideo from "@assets/home/howToVideo.webp";
import aiChip from "@assets/microchip.png";
import { Container, Grid, Typography } from "@mui/material";
import Video from "@components/Video";

const CreateAndSell = () => {
  const data = [
    {
      icon: tags,
      title: "High-Quality Images",
      text: "UE COMIX offers high-quality images that breathe life into your comix. Discover our meticulously crafted and strategic platform designed to elevate your sequential artwork.",
    },
    {
      icon: wallet,
      title: "Streamlined & Affordable",
      text: "Our AI-powered platform is designed to simplifies the initial stages and streamline your comix, ensuring you can focus on what matters most - bringing your stories to life!",
    },
    {
      icon: cloud,
      title: "Original & Authentic Content",
      text: "UE COMIX empowers you to create original and authentic comix that captivate your audience and set your brand or project apart leaving a lasting impression.",
    },
    {
      icon: folder,
      title: "Responsible Comix Creation",
      text: "Create comix with peace of mind, knowing that your artwork respects intellectual property rights, is legally sourced and copyright-free. ",
    },
  ];

  return (
    <div>
     
      <div className="container">
        <h1 className={styles.heading}>Key Features & Benefits</h1>
        <Container>
          <Spring delay={800}>
            <Grid container spacing={3} justifyContent="space-between">
              <Grid item xs={12} sm={3}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <img
                      style={{ height: "50px", width: "auto" }}
                      src={cloud}
                    ></img>
                  </div>
                  <div>
                    <Typography
                      variant="h5"
                      gutterBottom
                      style={{ marginTop: "1rem", fontWeight: 700 }}
                    >
                      The Creator's Lair
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="body1">
                      Unleash your artistic genius with our intuitive design
                      studio, tailored to your creative needs.
                    </Typography>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <img
                      style={{ height: "50px", width: "auto" }}
                      src={folder}
                    ></img>
                  </div>
                  <div>
                    <Typography
                      variant="h5"
                      gutterBottom
                      style={{ marginTop: "1rem", fontWeight: 700 }}
                    >
                      AI Co-Pilot
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="body1">
                      Imagine an AI sidekick that amplifies your creativity,
                      from storyboarding to penciling, inking, and beyond!
                    </Typography>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <img
                      style={{ height: "50px", width: "auto" }}
                      src={wallet}
                    ></img>
                  </div>
                  <div>
                    <Typography
                      variant="h5"
                      gutterBottom
                      style={{ marginTop: "1rem", fontWeight: 700 }}
                    >
                      Uncharted Territory
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="body1">
                      Focus on your story, not your expenses - flexible &
                      affordable pricing suited for your creative goals.
                    </Typography>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <img
                      style={{ height: "50px", width: "auto" }}
                      src={tags}
                    ></img>
                  </div>
                  <div>
                    <Typography
                      variant="h5"
                      gutterBottom
                      className={styles.feature_name}
                      style={{ marginTop: "1rem", fontWeight: 700 }}
                    >
                      Your Secret Sauce
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="body1">
                      UE COMIX helps you stir up something special! Blend your
                      ideas to create an original comix
                    </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Spring>
          <h1 className={styles.heading}>How It Works?</h1>
          <Video cover={HowToVideo} id="1lfEqLYowCM" />
        </Container>
      </div>
    </div>
  );
};

export default CreateAndSell;
